import { FadeIn, Section } from "../components/ui";
import { CheckCircle2, Star } from "lucide-react";
import { Seo } from "../components/Seo";

export function Servicos() {
  return (
    <main className="relative z-10 pt-32 pb-24">
      <Seo
        title="Serviços de Marketing, Branding e Automação com IA | P2A"
        description="Consultoria de marketing, gestão de redes sociais, lançamentos digitais, branding e automações com inteligência artificial para negócios físicos e digitais."
        path="/servicos"
      />
      {/* Header */}
      <Section className="py-16 text-center">
        <FadeIn>
          <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-6">
            Nossos <span className="font-highlight italic text-brand-accent lowercase font-normal">Serviços</span>
          </h1>
          <p className="text-xl text-brand-light/70 max-w-2xl mx-auto">
            Oferecemos soluções estratégicas para impulsionar o seu negócio e maximizar resultados.
          </p>
        </FadeIn>
      </Section>

      {/* Services List */}
      <Section className="py-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          <FadeIn>
            <div className="rounded-[2rem] overflow-hidden border border-brand-light/10 shadow-2xl relative group">
              <div className="absolute inset-0 bg-brand-accent/20 mix-blend-overlay z-10 group-hover:opacity-0 transition-opacity duration-500"></div>
              <img
                src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1024,h=825,fit=crop/mePxL7e2EOsb0a8L/20250224_ensaio_estudio_0302-YKb3GqRo4KI2WEBZ.jpg"
                alt="Notebook P2A"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
              />
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="space-y-8">
              <div className="space-y-2">
                <h3 className="text-2xl font-bold font-display text-brand-light">Consultoria e estratégia de Marketing</h3>
                <p className="text-brand-light/70 leading-relaxed">Analisamos seu negócio e criamos estratégias personalizadas para alcançar seus objetivos.</p>
              </div>
              
              <div className="space-y-2">
                <h3 className="text-2xl font-bold font-display text-brand-light">Gestão de Redes Sociais</h3>
                <p className="text-brand-light/70 leading-relaxed">Criamos e gerenciamos suas redes sociais para engajar e atrair clientes.</p>
              </div>

              <div className="space-y-2">
                <h3 className="text-2xl font-bold font-display text-brand-light">Lançamentos Digitais</h3>
                <p className="text-brand-light/70 leading-relaxed">Desenvolvemos estratégias para lançamentos de infoprodutos que geram resultados efetivos.</p>
              </div>

              <div className="space-y-2">
                <h3 className="text-2xl font-bold font-display text-brand-light">Branding e posicionamento</h3>
                <p className="text-brand-light/70 leading-relaxed">Construímos a essência da sua marca, propósito, tom de voz, identidade visual e definimos a estratégia de branding que vai gerar diferenciação e posicionamento no mercado.</p>
              </div>

              <div className="space-y-2">
                <h3 className="text-2xl font-bold font-display text-brand-light">Automações e inteligência artificial</h3>
                <p className="text-brand-light/70 leading-relaxed">Criamos robôs personalizados que atuam 24h por dia. Desenvolvemos robôs inteligentes e personalizados com I.A. para resolver exatamente o que o seu negócio precisa, seja ele físico ou digital.</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </Section>

      {/* O que nos torna únicos */}
      <Section className="py-24 bg-brand-light/5 border-y border-brand-light/5">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          <FadeIn>
            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-10">
              O que nos <br/>
              <span className="font-highlight italic text-brand-accent lowercase font-normal">torna únicos?</span>
            </h2>
            
            <ul className="space-y-6 text-lg text-brand-light/80">
              <li className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0 mt-1" />
                <p><strong className="text-brand-light">Estratégias Personalizadas:</strong> Nada de pacotes prontos. Cada negócio tem um plano sob medida.</p>
              </li>
              <li className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0 mt-1" />
                <p><strong className="text-brand-light">Do físico ao digital:</strong> Somos uma agência que entende negócios físicos e digitais, e isso faz toda a diferença.</p>
              </li>
              <li className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0 mt-1" />
                <p><strong className="text-brand-light">Foco em resultados reais:</strong> Trabalhamos com métricas claras, sem promessas vazias.</p>
              </li>
              <li className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0 mt-1" />
                <p><strong className="text-brand-light">Inovação com Inteligência Artificial:</strong> Utilizamos automação e IA para acelerar processos e melhorar a conversão.</p>
              </li>
              <li className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0 mt-1" />
                <p><strong className="text-brand-light">Gestão estratégica completa:</strong> Oferecemos um mix de serviços que cobre toda a jornada do marketing, desde branding até campanhas pagas e automação.</p>
              </li>
            </ul>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="relative rounded-[2rem] overflow-hidden border border-brand-light/10 shadow-2xl group">
              <div className="absolute inset-0 bg-brand-accent/10 mix-blend-overlay z-10 group-hover:opacity-0 transition-opacity duration-500"></div>
              <img
                src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1024,h=922,fit=crop/mePxL7e2EOsb0a8L/amanda-p2q-AR0Lgp9MlaT0aDzo.png"
                alt="Amanda - Automação Humanizada"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-6 right-6 z-20 bg-brand-dark/80 backdrop-blur-md border border-brand-light/10 p-4 rounded-xl max-w-[200px] text-center">
                <p className="text-sm font-bold text-brand-accent uppercase tracking-wider">Conheça a Amanda</p>
                <p className="text-xs text-brand-light/80 mt-1">Nossa automação humanizada</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </Section>

      {/* Testimonials */}
      <Section className="py-24">
        <div className="max-w-6xl mx-auto rounded-[2rem] overflow-hidden border border-brand-light/10 shadow-2xl flex flex-col md:flex-row bg-brand-dark/50">
          <div className="md:w-1/2 relative min-h-[300px] md:min-h-[500px]">
            <img
              src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=2560,fit=crop/mePxL7e2EOsb0a8L/img_1829-mePxKWPZWet9kBJX.jpg"
              alt="Depoimentos"
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-brand-dark/40 mix-blend-multiply"></div>
          </div>
          
          <div className="md:w-1/2 p-12 flex flex-col justify-center bg-brand-dark/80 backdrop-blur-sm">
            <FadeIn>
              <div className="mb-12 text-center">
                <div className="flex justify-center gap-1 mb-6 text-brand-accent">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 fill-brand-accent text-brand-accent" />
                  ))}
                </div>
                <p className="text-xl md:text-2xl font-medium text-brand-light/90 mb-6 leading-relaxed">
                  "A P2A Marketing e Branding transformou nosso negócio com estratégias eficazes e suporte excepcional. Super recomendo!"
                </p>
                <p className="font-bold text-brand-light uppercase tracking-widest text-sm">Adriana Saeka</p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2}>
              <div className="text-center">
                <div className="flex justify-center gap-1 mb-6 text-brand-accent">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 fill-brand-accent text-brand-accent" />
                  ))}
                </div>
                <p className="text-xl md:text-2xl font-medium text-brand-light/90 mb-6 leading-relaxed">
                  "Com as estratégias feitas adequadas para o meu negócio atingi o faturamento que desejava"
                </p>
                <p className="font-bold text-brand-light uppercase tracking-widest text-sm">Carolina Medeiro</p>
              </div>
            </FadeIn>
          </div>
        </div>
      </Section>
    </main>
  );
}
